var map = {
	"./ar.json": 9675,
	"./de.json": 532,
	"./en.json": 1005,
	"./es.json": 3458,
	"./fr.json": 1822,
	"./ja.json": 5723,
	"./ko.json": 3355,
	"./pt.json": 6709,
	"./ru.json": 8809,
	"./zh.json": 7073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8011;